import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

function AuthCheck() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  // Redirect based on auth state
  useEffect(() => {
    if (!loading) {
      if (user) {
        console.log("User is logged in, redirecting to Electron...");
        console.log("User data:", { email: user.email, name: user.displayName });

        // Build URL with user data
        const params = new URLSearchParams({
          email: user.email,
          name: user.displayName || user.email,
          uid: user.uid,
          photoURL: user.photoURL || ''
        });

        const appUrl = `edutools://login-complete?${params.toString()}`;
        console.log("Opening Electron with:", appUrl);
        window.location.href = appUrl;
      } else {
        // Not logged in, redirect to login page
        navigate("/login");
      }
    }
  }, [user, loading, navigate]);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#0a0a0a",
      color: "#ffffff",
      fontFamily: "system-ui, -apple-system, sans-serif",
      fontSize: "18px"
    }}>
      Checking...
    </div>
  );
}

export default AuthCheck;
